import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormatter',
})
export class NumberFormatter implements PipeTransform {
  transform(_number: any, lang: string = "fr"): any {
    if (_number) {
      let floatNumber = Number.parseFloat(_number);
      let lang = 'fr-FR';
      if (!lang || lang == 'fr') {
        lang = 'fr-FR';
      } else if (lang == 'en') {
        lang = 'en-US';
      }
      return floatNumber.toLocaleString(lang);
    }
  }
}
